import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articlesByLang } from "@/lib/articles";
import { articleImages } from "@/mocks/articleImages";

export default function ArticleCards({ lang }: { lang: string }) {
  const { t } = useTranslation();
  const articles = articlesByLang[lang] ?? [];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {articles.map((article, i) => (
        <Link
          key={article.slug}
          to={`/${lang}/${article.slug}`}
          className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
        >
          <div className="w-full h-40 md:h-44 overflow-hidden">
            <img
              src={articleImages[i % articleImages.length]}
              alt={article.h1}
              title={`${article.h1} — usfans spreadsheet`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="flex flex-col flex-1 p-5">
            <h3 className="font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
              {article.h1}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-3">
              {article.intro}
            </p>
            <div className="flex items-center justify-between">
              <span className="text-xs text-foreground-400">{article.readingTime}</span>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap">
                {t("nav.articles")}
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}